import * as CryptoJS from 'crypto-js';
import UserService from '../api/user/user';

export const loginMercureHandler = (parsedMessage, logOut, t, setAppError) => {
    // While impersonating ("login as user"), ignore the multi-user force-logout:
    // a subsequent login by the real user must not kick the impersonation session.
    if (UserService.isUserSwitching()) {
        return;
    }

    const hash = CryptoJS.SHA256(UserService.getToken()).toString(CryptoJS.enc.Hex);

    if (UserService.getToken() && hash !== parsedMessage.hash && parsedMessage.forceLogout) {
        logOut()
        setAppError(t('logout_mercure'))
    }
}

export const disableUserMercureHandler = (logOut, t, setAppError) => {
    logOut()
    setAppError(t('disable_user_mercure'))
}

export const logoutUserWithMessage = (logOut, t, setAppError) => {
    logOut()
    setAppError(t('logout_roles_change'))
}

export const importProgressHandler = (parsedMessage, setImportProgress) => {
    setImportProgress(parsedMessage)
}
